

/*var lastScrollTop = 70;
$(window).scroll(function(event){
    var st = $(this).scrollTop();
    if (st > lastScrollTop || st < 50){
		$('.header-group-top').removeClass('scrolling-up');
    } else {
		$('.header-group-top').addClass('scrolling-up');
    }
    lastScrollTop = st;
});*/

$(document).ready(function(){
    $(".scrollon").on('click', function(e){
    	e.preventDefault();
		var aid = $(this).attr("href");
    	$('html,body').animate({scrollTop: $(aid).offset().top-100},'slow');
    });
})